(() => {
  const moduleName = 'productPage';

  const productPageModule = App[moduleName] || {};

  App[moduleName] = (() => {
    const getStockInformationLens = function (data, callback) {
      return $.ajax({
        url: '/inStock/lens',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: (res) => callback && callback(res),
      });
    };

    const getStockStateObj = (stockState) => {
      const OUT_OF_STOCK = 'outOfStock';
      const NOT_IN_STOCK = '';
      const isOutOfStock = stockState === OUT_OF_STOCK || stockState === NOT_IN_STOCK;
      return {
        isOutOfStock,
        calculatedStockState: isOutOfStock ? OUT_OF_STOCK : stockState,
      };
    };

    return {
      ...productPageModule,
      getStockInformationLens,
      getStockStateObj,
    };
  })();
})();
